(ns common.widgets.preview-container
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react-use/lib/useMeasure$default" :as useMeasure]
            [common.util :refer [merge-refs]]
            [common.widgets.full-screen-preview :as full-screen-preview]
            [common.widgets.pan-zoom :as pan-zoom]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(def MIN-ZOOM 0.2)
(def MAX-ZOOM 1)
(def ZOOM-FACTOR 1.25)

(defui preview-toolbar [{:keys [toolbar-buttons scale zoom preview width height disable-fullscreen]
                         :or {disable-fullscreen false}}]
  ($ Stack
     {:direction "row"}
     ($ Stack
        {:flex 1
         :direction "row"
         :sx #js {:p 1}}
        toolbar-buttons)

     ($ Stack
        {:direction "row"
         :sx #js {:p 1
                  :borderLeft 1
                  :borderColor "grey.60"
                  :alignItems "center"}}
        ($ IconButton
           {:size "small"
            :onClick (fn [_]
                       (zoom true))
            :sx #js {:color "grey.10"}}
           ($ Icon "remove"))

        ;; TODO: Should this be a input or a button? What should it do?
        ($ Typography
           {:sx (fn [_theme]
                  #js {:fontSize "lg"
                       :mx 0.5
                       :minWidth "4.5rem"
                       :textAlign "center"})}
           (str (Math/round (* 100 scale)) "%"))

        ($ IconButton
           {:size "small"
            :onClick (fn [_]
                       (zoom false))
            :sx #js {:color "grey.10"}}
           ($ Icon "add")))

     (when-not disable-fullscreen
       ($ Stack
          {:direction "row"
           :sx #js {:p 1
                    :borderLeft 1
                    :borderColor "grey.60"}}
          ($ IconButton
             {:size "small"
              :onClick #(rf/dispatch [:modal/open {:id ::full-screen-preview/full-screen-preview
                                                   :props {:preview preview
                                                           :preview-width width
                                                           :preview-height height}}])}
             ;; Design calls for top-left - bottom-right arrow,
             ;; this could be flipped or something.
             ($ Icon
                {:sx #js {:transform "scaleX(-1)"}}
                "open_in_full"))))))

(defui preview-container [{:keys [width height preview preview-controls toolbar-buttons container-height
                                  min-zoom max-zoom zoom-factor scroll-zoom-enabled disable-fullscreen]
                           :or {min-zoom MIN-ZOOM
                                max-zoom MAX-ZOOM
                                zoom-factor ZOOM-FACTOR
                                container-height 400
                                scroll-zoom-enabled true}}]
  (let [[measure-ref measure] (useMeasure)

        available-width (.-width measure)
        available-height container-height

        ;; Calculate the template scaling by fitting it into the available space.
        ;; Leave 5% around the preview item.
        initial-scale (min (/ (* 0.95 available-width) width)
                           (/ (* 0.95 available-height) height)
                           1.0)

        [scale set-scale] (uix/use-state initial-scale)
        zoom (uix/use-callback (fn [down]
                                 (pan-zoom/update-zoom set-scale zoom-factor min-zoom max-zoom down))
                               [zoom-factor min-zoom max-zoom])
        zoom-control-ref (pan-zoom/use-zoom-control {:zoom zoom})

        [[x y] set-pos*] (uix/use-state [0 0])
        ;; Limit the pan so that the item is always visible.
        measured-w (.-width measure)
        measured-h (.-height measure)
        set-pos (uix/use-callback (fn [f]
                                    (pan-zoom/limited-set-pos set-pos* measured-w measured-h f))
                                  [measured-w measured-h])]

    ;; Set initial scaling when it is available or changes,
    ;; initial-scale depends on measure hook for the available width.
    (uix/use-effect (fn []
                      (set-scale initial-scale))
                    [initial-scale])
    ;; This paper component is the preview widget container now.
    ;; Probably could be moved to a shared compoent when this is used elsewhere.
    ($ Paper
       {:sx #js {:flex 1
                 :display "flex"
                 :flexDirection "column"
                 :overflow "hidden"}}
       ($ :div
          {:ref (cond-> measure-ref
                  scroll-zoom-enabled (merge-refs zoom-control-ref))}
          ($ pan-zoom/pan-area
             {:set-pos set-pos
              :style {:width "100%"
                      :height available-height}}
             ($ pan-zoom/checker)
             ($ pan-zoom/pan-item
                {:scale scale
                 :style (pan-zoom/centered-item-style x y width height)}
                preview)))
       preview-controls
       ($ preview-toolbar
          {:toolbar-buttons toolbar-buttons
           :scale scale
           :zoom zoom
           :preview preview
           :width width
           :height height
           :disable-fullscreen disable-fullscreen}))))
